class WebSocketClient {
  constructor (url, {
    maxReconnectAttempts = 5,
  } = {}) {
    this.url = url // WebSocket 服务地址
    this.socket = null // WebSocket 实例
    this.heartbeatInterval = 60000 // 心跳间隔
    this.reconnectDelay = 5000 // 重连间隔
    this.messageQueue = [] // 消息队列
    this.heartbeatTimer = null // 心跳定时器
    this.reconnectTimer = null // 重连定时器
    this.maxReconnectAttempts = maxReconnectAttempts // 最大重连次数
    this.reconnectAttempts = 0 // 当前重连次数
  }

  // 初始化连接
  connect () {
    this.socket = new WebSocket(this.url)
    // 连接打开
    this.socket.onopen = () => {
      this.reconnectAttempts = 0 // 重置重连次数
      this.startHeartbeat()
      this.flushMessageQueue()
    }

    // 接收消息
    this.socket.onmessage = (event) => {
      this.handleMessage(event.data)
    }

    // 连接关闭
    this.socket.onclose = () => {
      this.stopHeartbeat()
      this.reconnect()
    }

    // 连接错误
    this.socket.onerror = (error) => {
      console.error('连接错误', error)
      this.reconnect()
    }
  }

  // 发送消息
  send (message) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(message))
    } else {
      console.warn('WebSocket not open, adding message to queue:', message)
      this.messageQueue.push(message)
    }
  }

  // 处理服务器消息
  handleMessage (data) {
    try {
      const message = JSON.parse(data)
      console.log('Parsed message:', message)
    } catch (e) {
      console.error('Failed to parse message:', data)
    }
  }

  // 消息队列重发
  flushMessageQueue () {
    while (this.messageQueue.length > 0) {
      const message = this.messageQueue.shift()
      this.send(message)
    }
  }

  // 心跳机制
  startHeartbeat () {
    this.stopHeartbeat() // 防止重复启动
    this.heartbeatTimer = setInterval(() => {
      this.send('The heartbeat packets')
    }, this.heartbeatInterval)
  }

  stopHeartbeat () {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer)
      this.heartbeatTimer = null
    }
  }

  // 自动重连
  reconnect () {
    if (this.reconnectAttempts >= this.maxReconnectAttempts) {
      console.error('已经超过最大自动重连次数')
      return
    }
    if (this.reconnectTimer) return // 避免重复重连
    this.reconnectAttempts++ // 增加重连次数
    this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null
      this.connect()
    }, this.reconnectDelay)
  }

  // 关闭连接
  close () {
    this.stopHeartbeat()
    if (this.socket) {
      this.socket.close()
      this.socket = null
    }
  }
}

export default WebSocketClient
